import { motion } from 'framer-motion';

/**
 * Lamp（Aceternity UI 风格）— 顶部的锥形灯光效果，用于页面标题背景
 */
export function Lamp({ className = '' }: { className?: string }) {
  return (
    <div className={`pointer-events-none absolute inset-x-0 top-0 h-40 overflow-hidden ${className}`} aria-hidden="true">
      {/* 主灯光 */}
      <motion.div
        initial={{ opacity: 0, width: '8rem' }}
        animate={{ opacity: 1, width: '28rem' }}
        transition={{ delay: 0.2, duration: 1.2, ease: 'easeInOut' }}
        style={{ top: '0.5rem', filter: 'blur(20px)' }}
        className="absolute left-1/2 h-12 -translate-x-1/2 rounded-full bg-gradient-to-r from-transparent via-primary to-transparent"
      />
      <motion.div
        initial={{ opacity: 0, width: '6rem' }}
        animate={{ opacity: 0.65, width: '20rem' }}
        transition={{ delay: 0.3, duration: 1.2, ease: 'easeInOut' }}
        style={{ top: '1.1rem', filter: 'blur(34px)' }}
        className="absolute left-1/2 h-16 -translate-x-1/2 rounded-full bg-gradient-to-r from-transparent via-accent-cyan to-transparent"
      />
      {/* 锥形光柱 */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.35 }}
        transition={{ delay: 0.4, duration: 1 }}
        style={{
          top: '-1rem',
          width: '12rem',
          height: '10rem',
          filter: 'blur(26px)',
          background: 'conic-gradient(from 90deg at 50% 0%, transparent 40%, #e11d2e 50%, transparent 60%)',
        }}
        className="absolute left-1/2 -translate-x-1/2"
      />
    </div>
  );
}
